import { getDefaultFilter } from "../../constants/defaultPagebleFilter";

const actions = {
    GET_DEVICES: "GET_DEVICES",
    ADD_DEVICE:"ADD_DEVICE",
    EDIT_DEVICE: "EDIT_DEVICE"
}

const initialState = {
    devices: [],
    filter: getDefaultFilter()
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
    case actions.GET_DEVICES:
    {
        return {
            ...state,
            devices: action.payload.devices,
            filter: action.payload.filter
        };
    }
    case actions.ADD_DEVICE:
    {
        return {
            ...state,
            devices: [ ...state.devices, action.device ]
        };
    }
    case actions.EDIT_DEVICE:
    {
        return {
            ...state,
            devices: state.devices.map((item, index) => {
                if (item.deviceId !== action.device.deviceId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            })
        };
    }
    default:
        return state;
    }
};


export const setDevices  = (devices, filter) => ({type: actions.GET_DEVICES, payload: {devices, filter}});
export const addDevice = (device) => ({type: actions.ADD_DEVICE, device});
export const editDevice = (device) => ({type: actions.EDIT_DEVICE, device});

